import { render, staticRenderFns } from "./qz-tray-form-nested.vue?vue&type=template&id=1b4f9fc6&scoped=true&"
import script from "./qz-tray-form-nested.vue?vue&type=script&lang=js&"
export * from "./qz-tray-form-nested.vue?vue&type=script&lang=js&"
import style0 from "./qz-tray-form-nested.vue?vue&type=style&index=0&id=1b4f9fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f9fc6",
  null
  
)

export default component.exports